var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('b-modal', {
    staticClass: "tips",
    attrs: {
      "id": "modal-tip",
      "scrollable": "",
      "centered": "",
      "hide-header": _vm.tip && !_vm.tip.title,
      "hide-footer": _vm.tip && !_vm.tip.button_text
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "font-weight-bold h6 mb-0"
        }, [_vm._v(" " + _vm._s(_vm.tip.title) + " ")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('button', {
          staticClass: "tips__close",
          on: {
            "click": function click($event) {
              return _vm.close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("./images/close.svg")
          }
        })]), _c('div', {
          staticClass: "p-2",
          style: _vm.colorObject
        }, [_vm.tip.content ? _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.tip.content)
          }
        }) : _vm._e()])];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', {
          staticClass: "flex-fill",
          style: _vm.colorObject
        }, [_c('SharedButton', {
          staticClass: "w-100",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_vm._v(_vm._s(_vm.tip.button_text))])], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "s-container"
  }, [_vm.registrationCheckIsDone ? [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "show-member-center": false,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('router-view')] : _c('Loading')], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }